// removed by extract-text-webpack-plugin
module.exports = {"containerSmartApp":"style__containerSmartApp__1hcGD","icon":"style__icon__13vrQ","close":"style__close__1FABk","content":"style__content__2kVxQ","installBtnContainer":"style__installBtnContainer__h6PKv","installBtn":"style__installBtn__1bqBY","reviewRatingStar":"style__reviewRatingStar__SyZ7z","description":"style__description__34Q9b"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SmartAppBanner/style.css
// module id = 2109
// module chunks = 0